import { useEffect } from "react";

// 图片加载性能监控
export const measureImageLoad = (imageName) => {
  performance.mark(`image-${imageName}-start`);

  return () => {
    performance.mark(`image-${imageName}-end`);
    performance.measure(
      `image-${imageName}`,
      `image-${imageName}-start`,
      `image-${imageName}-end`
    );

    // 获取性能数据
    const measure = performance.getEntriesByName(`image-${imageName}`)[0];
    if (measure) {
      console.log(
        `📊 Image ${imageName} loaded in: ${measure.duration.toFixed(2)}ms`
      );
    }
  };
};

// 监控 Core Web Vitals
export const observeWebVitals = () => {
  // LCP (Largest Contentful Paint)
  const observeLCP = new PerformanceObserver((entryList) => {
    const entries = entryList.getEntries();
    const lastEntry = entries[entries.length - 1];
    console.log("🎯 LCP:", lastEntry.startTime.toFixed(2), "ms");
  });

  // FID (First Input Delay)
  const observeFID = new PerformanceObserver((entryList) => {
    for (const entry of entryList.getEntries()) {
      console.log("⚡ FID:", entry.processingStart - entry.startTime, "ms");
    }
  });

  // CLS (Cumulative Layout Shift)
  const observeCLS = new PerformanceObserver((entryList) => {
    let clsValue = 0;
    for (const entry of entryList.getEntries()) {
      if (!entry.hadRecentInput) {
        clsValue += entry.value;
      }
    }
    console.log("📐 CLS:", clsValue.toFixed(4));
  });

  try {
    observeLCP.observe({ entryTypes: ["largest-contentful-paint"] });
    observeFID.observe({ entryTypes: ["first-input"] });
    observeCLS.observe({ entryTypes: ["layout-shift"] });
  } catch (e) {
    console.log("⚠️ Performance monitoring not supported");
  }
};

// React Hook 用于性能监控
export const usePerformanceMonitor = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      observeWebVitals();

      // 监控资源加载
      const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (entry.initiatorType === "img") {
            console.log(
              `🖼️ Image loaded: ${entry.name} - ${entry.duration.toFixed(2)}ms`
            );
          }
        }
      });

      observer.observe({ entryTypes: ["resource"] });

      return () => {
        observer.disconnect();
      };
    }
  }, []);
};

// 监控懒加载性能
export const useLazyLoadMonitor = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const target = entry.target;
            const imageName =
              target.getAttribute("data-image-name") || "unknown";
            console.log(`👁️ Image entered viewport: ${imageName}`);
          }
        });
      });

      // 监控所有带有懒加载的图片
      const lazyImages = document.querySelectorAll('[data-lazy="true"]');
      lazyImages.forEach((img) => observer.observe(img));

      return () => observer.disconnect();
    }
  }, []);
};

const PerformanceMonitorUtils = {
  measureImageLoad,
  observeWebVitals,
  usePerformanceMonitor,
  useLazyLoadMonitor,
};

export default PerformanceMonitorUtils;
